import customAxios from "../api/interceptors";

export const getAllInvoicesService = () => customAxios.get(`/company/invoices`)